<script>
import BarChart from "@/components/charts/BarChart.vue";
import LineChart from "@/components/charts/LineChart.vue";

export default {
    name: "OrdersTab",

    data() {

        return {
            loadGraph: true,
            chartData: {
      labels: ['January', 'February', 'March', 'April', 'May'],
      datasets: [
        {
          label: 'Sales',
          backgroundColor: '#f87979',
          data: [40, 20, 12, 39, 10]
        }
      ]
    },
     chartDatatimedistributionx: {
      labels: ['January', 'February', 'March', 'April', 'May'],
      datasets: [
        {
          label: 'Visit Time Distribution',
          backgroundColor: '#f66749',
          data: [40, 20, 12, 39, 10]
        }
      ]
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false
    },
    dashboarddata:{
         totalRegistered: 0, 
         totalVisits: 0,
         totalMale: 0, 
         totalFemale: 0,
          totalNewVisits: 0,
         totalChildrenVisit: 0,
         totalAdolescenceVisit: 0,
         totalAdultsVisit: 0,
         visitTimeDistribution:{}}, 
    orders: [],
            currentOrder: {},
            filter: {
                status: 1,
                from: this.$moment().startOf('month').format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
            },
            reqItems: [],
            fulfilledItems: [],
            view: false,
            fulfill: false,
            decline: false,
            addTransferReq: false,
            addOrder: false,

            patient: {patienT_ID:799},
           // compulsoryfileupload:this.$root.companyconfigsdocumentvisitupload,
            patientVisit: {
                visitId: 0,
                customerId: this.$route.params.patientID,
                userName: this.$root.username,
                visitCharges: [],
                clinicId: 0,
                billed: true,
                visitTypeId: 0,
            },
            fileUpload: {
                name: ``,
                ref: ``,
                description: ``,
                file: null,
            },
            clinicCharges: [],
            insurance: false,
            confirmSave: false,
            patientInsurances: [],
            insurances: [],
            dependants: [],
            patientInsurancesForUse: [],
            errors: [],
            fileErrors: [],
            patientDocuments: [],
            viewDocuments: false,

            clinics: [],
            visits: [],
            doctors: [],
            visittypes: [],
            processingmodes:[],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetDashboardData(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetDashboardData() {
            let url = `DashBoard/GetDashboardReport`;
            // switch (this.filter.status) {
            //     case 1:
            //         url = `Inventory/GetRequisitonsNotApprovedfilterDate`;
            //         break;
            //     case 2:
            //         url = `Inventory/GetRequisitonsApprovedfilterDate`;
            //         break;
            //     case 3:
            //         url = `Inventory/GetRequisitonsDeclinedfilterDate`;
            //         break;
            
            //     default:
            //         url = `Inventory/GetRequisitonsApprovedfilterDate`;
            //         break;
            // }

            url += `?Datefrom=${this.filter.from}`;
            url += `&Dateto=${this.filter.to}`;

            return this.$http.get(url).then(({ data }) => {
              //  this.dashboarddata = data.map(order => ({...order, view: false, }));
                this.dashboarddata = data;
            //     this.chartDatatimedistribution.labels=this.dashboarddata.VisitTimeDistribution.dayTime
            //     this.chartDatatimedistribution.datasets[0].data=this.dashboarddata.visitTimeDistribution.visitTime
             }).catch(() => {});
        },

        fetchOrderItems(reqNo) {
            this.$root.loading = true;
            let url = `Inventory/GetInventoryRequisitionItems`;
                url += `?RequistionNo=${reqNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.reqItems = data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchfulfilledItems(reqNo) {
            let url = `Inventory/GetFufilledRequisitonItems`;
                url += `?RequisitionNo=${reqNo}`;
            
            return this.$http.get(url).then(({ data }) => {
                this.fulfilledItems = data;
            }).catch(() => {});
        },

        fetchOrderDetails(reqNo) {

            return Promise.all([ this.fetchfulfilledItems(reqNo), this.fetchOrderItems(reqNo), ]);
        },
    },
    computed: {

        chartDatatimedistribution() {
        //    let chardata=this.dashboarddata.visitTimeDistribution.visitTime;
        let labels=this.dashboarddata.visitTimeDistribution.visitTimeAll.map(vt => vt.visitHour);
        let labelsdata=this.dashboarddata.visitTimeDistribution.visitTimeAll.map(vt => vt.noofPatients);
  let  chartDatatimedistributionx= {
      labels: labels,
      datasets: [
        {
          label: 'Visits',
          backgroundColor: '#dbfc03',
          data: labelsdata
        }
      ]
    }
 
    // if(!this.invoiceItems.length) return 0;

    // const filteredItems = this.invoiceItems.filter(invItem => invItem.insuranceAmountPaid);

    // if(!filteredItems.length) return 0;

    // const invItems = filteredItems.map(item => parseFloat(item.insuranceAmountPaid));

    // return invItems.reduce((cost, accTotal) => cost + accTotal);
    return chartDatatimedistributionx;
}, 
chartDatamonthdistribution() {
         let labels=this.dashboarddata.monthsofYear;
         let labelsdata=this.dashboarddata.visitTimeDistribution.visitMonthAll.map(vt => vt.noofPatients);
  let  chartDatatimedistributionx= {
      labels: labels,
      datasets: [
        {
          label: 'Visits',
          backgroundColor: '#f87979',
          data: labelsdata
        }
      ]
    }
  return chartDatatimedistributionx;
},
chartDataBillsmonthdistribution() {
         let labels=this.dashboarddata.monthsofYear;
         let labelsdata=this.dashboarddata.visitTimeDistribution.billsMonthAll.map(vt => vt.grandTotal);
  let  chartDatatimedistributionx= {
      labels: labels,
      datasets: [
        {
          label: 'Grand Total',
          backgroundColor: '#4CAF50',
          data: labelsdata
        }
      ]
    }
  return chartDatatimedistributionx;
},
},
    components: {

       
        'bar-chart': BarChart,
        'line-chart': LineChart,
        
    },
}
</script>
<template>
    
<div class="w-full flex flex-wrap items-center">
    <order-form 
        :showModal="$route.query.active ? true : false"
        @refresh="$refs.ordersTab.fetDashboardData()"
        @closeModal="$router.push({ 
            name: `inventory-management.orders.index`, 
        })"
    />
    <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap border-2 border-blue-500 text-xs px-1 
                            rounded-b-md">
                            <div class="md:w-1/3 w-1/2 p-1">
            <label for="grid-filter-from" class="label-control">From</label>
            <input type="date" id="grid-filter-from" 
                v-model.trim="filter.from"
                class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/3 w-1/2 p-1">
            <label for="grid-filter-to" class="label-control">To</label>
            <input type="date" id="grid-filter-to" 
                v-model.trim="filter.to"
                class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/3 w-1/2 p-1">
            <button 
            @click.prevent="() => {
                $root.loading = true;
                fetDashboardData().then(() => {
                    $root.loading = false;
                });
            }"
            class="btn-sm btn-primary text-xs rounded mt-5">
                <i class="fa fa-filter"></i> Filter
            </button>
        </div> 
        
                       </div> <div class="flex md:flex-row sm:flex-col overflow-auto">
                  <div class="flex-1 flex flex-wrap content-start p-1 overflow-auto" style="max-height:75vh;">
                       <div class="w-full p-tiny bg-blue-500 text-sm text-white rounded-t-md">
                           <h5 class="font-bold">Client Flow Analysis</h5> 
                       </div>
                        
                       <div class="w-1/2 flex flex-wrap border-2 border-blue-500 text-xs px-1 
                            rounded-b-md">
                            <div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Registered:</h5>
                               <h5 class="font-semibold capitalize">{{ dashboarddata.totalRegistered }}</h5>
                               
                             </div>
                           <div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Reg Male:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalMale }}</span></h5>
                           </div><div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Reg Female:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalFemale }}</span></h5>
                                  
                           </div>
                       </div>
                       <div class="w-1/2 flex flex-wrap border-2 border-blue-500 text-xs px-1 
                            rounded-b-md">
                            <div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Visits:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalVisits }}</span></h5>
                           </div>
                           <div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total New Visit:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{  dashboarddata.totalNewVisits }}</span></h5>
                           </div><div class="md:w-1/3 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Return Visit:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalVisits- dashboarddata.totalNewVisits }}</span></h5>
                           </div> 
                           <!-- <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Return Visits:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{dashboarddata.totalVisits-  dashboarddata.totalNewVisits }}</span></h5>
                           </div> -->
                       </div>
                      
                       <div class="w-full flex flex-wrap border-2 border-blue-500 text-xs px-1 
                            rounded-b-md">
                          
                          
                           
                           <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold"> Male Visits:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                {{ dashboarddata.totalMaleVisit }}</span></h5>
                           </div>
                           
                           
                           <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold"> Female Visits:</h5>
                               <h5 class="font-semibold"> <span class="text-blue-800">
                                {{ dashboarddata.totalFemaleVisit }}</span></h5>
                           </div>
                           <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold">Children Visit:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalChildrenVisit }}</span></h5>
                           </div>
                           <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold">Adolescents Visit:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalAdolescenceVisit }}</span></h5>
                           </div>
                           <div class="md:w-1/6 sm:w-full p-tiny">
                               <h5 class="font-bold"> Adults Visit:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{dashboarddata.totalAdultsVisit }}</span></h5>
                           </div> 
                       </div>
                      
                       <div class="w-full overflow-auto mt-2">
                        <div class="w-full">
                            <div class="w-full p-tiny bg-yellow-500 rounded-t">
                          <h5 class="text-white text-sm">Visit Distribution Graph: Number of Patients Vurses the Hour of Day</h5>
                      </div>  <line-chart v-if="loadGraph" :chartData="chartDatatimedistribution" />
          </div>   <div class="w-full">
            <div class="w-full p-tiny bg-red-500 rounded-t">
                          <h5 class="text-white text-sm">Monthly Visit Distribution Graph: Number of Patients Vurses the Month of Year</h5>
                      </div> <bar-chart v-if="loadGraph" :chartData="chartDatamonthdistribution" />
          </div>  
           
                        </div>
                       
                  </div>
                  <div class="flex-1 flex flex-wrap content-start overflow-auto 
                    border-2 border-blue-500 rounded" style="height:75vh;">
                      <div class="w-full p-tiny bg-blue-500 rounded-t">
                          <h5 class="text-white text-sm">Revenue Analysis</h5>
                      </div>
                      
                      <div class="w-full flex flex-wrap border-2 border-blue-500 text-xs px-1 
                            rounded-b-md">
                            <div class="md:w-1/4 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Billed:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">{{ dashboarddata.totalGrandTotal | numberFormat}} </span></h5>
                               
                             </div>
                           <div class="md:w-1/4 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Cash Paid:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalCashPaid | numberFormat}}</span></h5>
                           </div><div class="md:w-1/4 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Insurance:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalInsurance | numberFormat}}</span></h5>
                                  
                           </div>
                           <div class="md:w-1/5 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Weivers:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalWeiver | numberFormat}}</span></h5>
                                  
                           </div> <div class="md:w-1/5 sm:w-full p-tiny">
                               <h5 class="font-bold">Total Balances:</h5>
                               <h5 class="font-semibold"><span class="text-blue-800">
                                   {{ dashboarddata.totalBalance | numberFormat}}</span></h5>
                                  
                           </div>
                       </div>
                       
                        <div class="w-full overflow-auto mt-2">
                        <div class="w-full">
                            <div class="w-full p-tiny bg-green-500 rounded-t">
                          <h5 class="text-white text-sm">Bills Distribution Graph: Grand Total Bills Vurses the Month of Year</h5>
                      </div>  <bar-chart v-if="loadGraph" :chartData="chartDataBillsmonthdistribution" />
          </div>    
           
                        </div>
                       
                      
                      
                    </div>
              </div>
              
              
        
       
    </div>
  
    
     
</div>
</template>
